var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.decision && _vm.decision.prompt && _vm.decision.prompt.trim() !== '')?_c('div',{staticClass:"prompt",style:(_vm.style)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.decision.prompt)}})]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f54383a4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/ui/DecisionPrompt.vue
// module id = null
// module chunks = 